module.exports = __webpack_public_path__ + "assets/637d04828404875cad7e273a8751383d.png";